import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const AccountDetails = ({
  product,
  handleOpenCreateFolderModal,
  searchDocuments,
}: {
  product: any;
  searchDocuments: any;
  handleOpenCreateFolderModal: () => void;
}) => {
  const { version, name } = product;
  return (
    <Grid container alignItems="center">
      <Grid container item xs={12}>
        <Grid item md={3} xs={12} className="knowledgebase-details-title">
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "12px",
              color: "#00000099",
            }}
          >
            Account Name
          </Typography>
          <Typography
            sx={{
              fontSize: "12px",
              color: "#00000099",
            }}
          >
            {name}
          </Typography>
        </Grid>
        <Grid item md={3} xs={12} className="knowledgebase-details-title">
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "12px",
              color: "#00000099",
            }}
          >
            Version
          </Typography>
          <Typography
            sx={{
              fontSize: "12px",
              color: "#00000099",
            }}
          >
            {version}
          </Typography>
        </Grid>

        <Grid
          item
          md={6}
          xs={12}
          textAlign="right"
          className="knowledgebase-details-title"
        >
          <Button
            className="guideTourKBCreateFolder"
            variant="contained"
            onClick={handleOpenCreateFolderModal}
            disabled={searchDocuments.length >= 5}
          >
            CREATE FOLDER
          </Button>
          <Box>
            <span className="title-tooltip">
              Create folder to upload knowledge base. Maximum of 5 folders
              allowed.{" "}
            </span>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AccountDetails;
